































































































import { $eventsBus } from "@/main";
import { VPopover, VClosePopover } from "v-tooltip";
import BaseButton from "@/app/shared/components/base/BaseButton.vue";
import PartsCreatorTimeline from "@/app/modules/work/components/bottom-panel/TheBottomPanelPartsCreatorTimeline.vue";
import PartsMixerTimeline from "@/app/modules/work/components/bottom-panel/TheBottomPanelPartsMixerTimeline.vue";

export default {
  name: "BottomPanel",
  components: {
    VPopover,
    BaseButton,
    PartsCreatorTimeline,
    PartsMixerTimeline,
  },
  directives: {
    "close-popover": VClosePopover,
  },
  data: function () {
    return {
      timelineZoom: 100,
    };
  },
  computed: {
    keymap: function () {
      return {};
    },
    items() {
      return this.$store.state.items;
    },
    itemsToShow: function () {
      return this.$store.state.items.filter((i) => !i.hidden);
    },
    previewItem: function () {
      return this.$store.state.selectedItem;
    },
    allParts: function () {
      return this.$store.state.items.reduce(
        (acc, val) => acc.concat(val.parts),
        []
      );
    },
    selectedPart: {
      get: function () {
        return this.$store.state.selectedPart;
      },
      set: function (part) {
        this.$store.commit("changeSelectedPart", part);
      },
    },
    contentVideoCurrentTime: {
      get: function () {
        return this.$store.state.contentVideoCurrentTime;
      },
      set: function (value) {
        this.$store.commit("contentVideoCurrentTime", value);
      },
    },
    mixedParts: {
      get: function () {
        return this.$store.state.mixedParts;
      },
      set: function (mixedParts) {
        this.$store.commit("mixedParts", mixedParts);
      },
    },
    isMixerStep: {
      get: function () {
        return this.$store.state.isMixerStep;
      },
      set: function (isMixerStep) {
        this.$store.commit("isMixerStep", isMixerStep);
      },
    },
  },
  watch: {},
  methods: {
    onCreateVideo() {
      if (!this.isMixerStep && this.allParts.length === 0) {
        return;
      }
      this.isMixerStep = !this.isMixerStep;
      if (this.isMixerStep) {
        if (this.mixedParts.length !== 0) {
          this.selectedPart = this.mixedParts[0];
        } else {
          this.selectedPart = null;
        }

        this.$store.commit(
          "changeSelectItem",
          !!this.selectedPart
            ? this.items.find(
                (i) => i.id === this.selectedPart.parentItemInfo.id
              )
            : null
        );

        $eventsBus.$emit("setVideoPaused", true);
        this.contentVideoCurrentTime = 0;
        $eventsBus.$emit("setContentTime", 0);
      }
    },
    onBackToCreating() {
      this.isMixerStep = !this.isMixerStep;
      if (!this.isMixerStep) {
        $eventsBus.$emit("setVideoPaused", true);
        $eventsBus.$emit("setContentTime", 0);
      }
    },
    isCanExport() {
      return (
        this.mixedParts.length !== 0 &&
        this.mixedParts.every(
          (p) =>
            p.parentItemInfo.fileId !== null && p.parentItemInfo.fileId !== 0
        )
      );
    },
    onExportVideo() {
      if (!this.isCanExport()) {
        return;
      }
      $eventsBus.$emit("exportItems");
      $eventsBus.$emit("openTabInRightPanel", "Render Queue");
    },
    onAddNewPart(item) {
      let currentTimeOfItem =
        this.contentVideoCurrentTime -
        this.getDurationOfPreviousItemsToShow(item);
      let startTime = 0;
      let finishTime = 0;
      if (currentTimeOfItem + 5 > item.duration) {
        startTime = 0;
        finishTime = item.duration;
      } else {
        startTime = currentTimeOfItem;
        finishTime = currentTimeOfItem + 5;
      }
      item.addNewItemPart(startTime, finishTime);
    },
    getDurationOfPreviousItemsToShow(item) {
      let itemIndex = this.itemsToShow.indexOf(item);
      if (itemIndex === -1) {
        return 0;
      }
      let allDuration = 0;
      for (let index = 0; index < itemIndex; index++) {
        allDuration += this.itemsToShow[index].duration;
      }
      return allDuration;
    },
    zoomIn() {
      if (this.timelineZoom >= 300) {
        this.timelineZoom = 300;
      } else {
        this.timelineZoom += 10;
      }
    },
    zoomOut() {
      if (this.timelineZoom <= 100) {
        this.timelineZoom = 100;
      } else {
        this.timelineZoom -= 10;
      }
    },
  },
};
